module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.d2a55d331bdd1a7ea97a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design-iconic-font/Material-Design-Iconic-Font.woff?v=2.2.0
// module id = 1853
// module chunks = 19